var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup42(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 153.645,
    height: 153.647,
    viewBox: "0 0 153.645 153.647",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42",
    "data-name": "Group 42",
    transform: "translate(1056.125 -1818.326)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M83.883,913.916H69.763a3.715,3.715,0,0,0-3.715,3.715v18.384a.734.734,0,0,0,.176.474l1.967,2.3a.727.727,0,0,0,1.1,0l1.59-1.857a.724.724,0,0,1,1.1,0l1.591,1.857a.726.726,0,0,0,1.1,0l1.588-1.857a.726.726,0,0,1,1.1,0l1.591,1.857a.723.723,0,0,0,1.1,0l1.591-1.857a.727.727,0,0,1,1.105,0l1.59,1.857a.724.724,0,0,0,1.1,0l1.97-2.3a.731.731,0,0,0,.173-.474V917.631a3.715,3.715,0,0,0-3.715-3.715m-13.147,3.069a2.421,2.421,0,1,1-2.419,2.419,2.418,2.418,0,0,1,2.419-2.419m9.671,13.346H68.317v-1.849h12.09Zm0-3.314H68.317v-1.849h12.09Zm3.413-6.2a.942.942,0,0,1-.941.941H75.345a.943.943,0,0,1-.941-.941v-2.827a.941.941,0,0,1,.941-.941h7.534a.94.94,0,0,1,.941.941Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M66.048,907.014H87.6l6.017-55.746H60.031Z",
    transform: "translate(-1056.125 999.996)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M76.822,818.33a76.823,76.823,0,1,0,76.823,76.824A76.91,76.91,0,0,0,76.822,818.33m0,139.39a62.566,62.566,0,1,1,62.567-62.566A62.637,62.637,0,0,1,76.822,957.72",
    transform: "translate(-1056.125 999.996)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup42);
export default __webpack_public_path__ + "static/media/Group 42.48d8b061d949f5bf4e98b9794f5a55fb.svg";
export { ForwardRef as ReactComponent };